// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/maneuver_config.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { RigEffectiveConfig } from "../atk/effective_config";

export const protobufPackage = "carbon.rtc";

export interface ManeuverConfiguration {
  effectiveConfig: RigEffectiveConfig | undefined;
  speedMS: number;
}

function createBaseManeuverConfiguration(): ManeuverConfiguration {
  return { effectiveConfig: undefined, speedMS: 0 };
}

export const ManeuverConfiguration: MessageFns<ManeuverConfiguration> = {
  encode(message: ManeuverConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.effectiveConfig !== undefined) {
      RigEffectiveConfig.encode(message.effectiveConfig, writer.uint32(10).fork()).join();
    }
    if (message.speedMS !== 0) {
      writer.uint32(17).double(message.speedMS);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ManeuverConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManeuverConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.effectiveConfig = RigEffectiveConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.speedMS = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManeuverConfiguration {
    return {
      effectiveConfig: isSet(object.effectiveConfig)
        ? RigEffectiveConfig.fromJSON(object.effectiveConfig)
        : isSet(object.effective_config)
        ? RigEffectiveConfig.fromJSON(object.effective_config)
        : undefined,
      speedMS: isSet(object.speedMS)
        ? globalThis.Number(object.speedMS)
        : isSet(object.speed_m_s)
        ? globalThis.Number(object.speed_m_s)
        : 0,
    };
  },

  toJSON(message: ManeuverConfiguration): unknown {
    const obj: any = {};
    if (message.effectiveConfig !== undefined) {
      obj.effectiveConfig = RigEffectiveConfig.toJSON(message.effectiveConfig);
    }
    if (message.speedMS !== 0) {
      obj.speedMS = message.speedMS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManeuverConfiguration>, I>>(base?: I): ManeuverConfiguration {
    return ManeuverConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManeuverConfiguration>, I>>(object: I): ManeuverConfiguration {
    const message = createBaseManeuverConfiguration();
    message.effectiveConfig = (object.effectiveConfig !== undefined && object.effectiveConfig !== null)
      ? RigEffectiveConfig.fromPartial(object.effectiveConfig)
      : undefined;
    message.speedMS = object.speedMS ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
